<template>
  <div class="card">
    <div :class="car.className[0]" :key="car.id" v-for="car in cars">
      <div class="card__img">
        <img :src="require(`../../assets/column-preview/${car.img_url}`)" alt="Sedans" />
      </div>
      <div class="card__content">
        <h3 class="card__title">{{car.title}}</h3>
        <p class="card__description">{{car.text}}</p>
      </div>
      <div class="card__cta">
        <a href="" class="button" :class="car.className[1]">Learn More</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    cars: Array,
  },
};
</script>

<style lang="scss" scoped>
  .card {
    font-size: var(--fs-h3);

    @media (min-width: 90em) {
      display: flex;
    }

    &--sedan, &--suv, &--luxury {
      margin: 0 auto;
      padding: var(--bg-spacer);
    }

    &--sedan {
      background-color: var(--bright-orange);
      border-radius: var(--border-radius) var(--border-radius) 0 0 ;
      @media (min-width: 90em) {
        border-radius: var(--border-radius) 0 0 var(--border-radius);
      }
    }

    &--suv {
      background-color: var(--dark-cyan);
      border-radius: initial;
      @media (min-width: 90em) {
        border-radius: initial;
      }
    }

    &--luxury {
      background-color: var(--very-dark-cyan);
      border-radius: 0 0  var(--border-radius) var(--border-radius);
      @media (min-width: 90em) {
        border-radius: 0 var(--border-radius) var(--border-radius) 0;
      }
    }

    &__description {
      line-height: 1.6;
      color: var(--transparent-bg);
      max-width: 30ch;
      padding-bottom: var(--bg-spacer);
    }

    &__img {
      padding-bottom: var(--sm-spacer);
    }

    &__title {
      font-family: var(--ff-alt);
      font-size: var(--fs-h2);
      color: var(--very-light-gray);
      text-transform: uppercase;
      padding-bottom: 0.2rem;
    }

    .button {
      background-color: var(--transparent-btn-bg);
      padding: 0.5em 2em;

      &--sedan {
        color: var(--bright-orange);
      }

      &--suv {
        color: var(--dark-cyan);
      }

      &--luxury {
        color: var(--very-dark-cyan);
      }

      &:hover {
        background-color: transparent;
        color: var(--transparent-btn-bg);
      }
  }
}
</style>
